import { render } from "./TagEngine.vue?vue&type=template&id=6854971c&scoped=true"
import script from "./TagEngine.vue?vue&type=script&lang=js"
export * from "./TagEngine.vue?vue&type=script&lang=js"

import "./TagEngine.vue?vue&type=style&index=0&id=6854971c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6854971c"]])

export default __exports__